/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of notification to receive.
 * @export
 */
export const SubscriptionNotificationType = {
    Updates: 'UPDATES',
    Events: 'EVENTS',
    Acl: 'ACL'
} as const;
export type SubscriptionNotificationType = typeof SubscriptionNotificationType[keyof typeof SubscriptionNotificationType];


export function instanceOfSubscriptionNotificationType(value: any): boolean {
    for (const key in SubscriptionNotificationType) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionNotificationType, key)) {
            if (SubscriptionNotificationType[key as keyof typeof SubscriptionNotificationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionNotificationTypeFromJSON(json: any): SubscriptionNotificationType {
    return SubscriptionNotificationTypeFromJSONTyped(json, false);
}

export function SubscriptionNotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionNotificationType {
    return json as SubscriptionNotificationType;
}

export function SubscriptionNotificationTypeToJSON(value?: SubscriptionNotificationType | null): any {
    return value as any;
}

export function SubscriptionNotificationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionNotificationType {
    return value as SubscriptionNotificationType;
}

